import React from 'react';

import { useTranslation } from 'react-i18next';

export default function LangDemo() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      <button onClick={() => changeLanguage('th')}>th</button>
      <button onClick={() => changeLanguage('en')}>en</button>
      {t('คลังข้อมูลน้ำแห่งชาติ')}
    </>
  );
}
